import React, { useEffect, useState } from "react";
import "./CohortView.scss";
import { useDispatch, useSelector } from "react-redux";
import exportimages from "../../../../assets/images/exportImages";
import { useGetInitialFIListQuery } from "../../../../rtk-query/features/cohort/cohortRTK";
import {
  removeInstitution,
  setResetSearchTextForCities,
  setSelectedAdditionalInstitutions,
  setSelectedInstitutions,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import { sortInstitutions } from "../CohortFilter/SearchAdditionalInstitutionInput";
import { CreateCohortModel, CREATE_MODEL } from "./CreateCohortModel";
import { FiMinus } from "react-icons/fi";
import { Skeleton } from "primereact/skeleton";
import useFetch from "../../../../rtk-query/features/useFetch";
import { usePermissions } from "../../../../hooks/usePermissions";
import { useSubscription } from "../../../../hooks/useSubscription";
import { PRIVILEGES } from "../../../../utils/privileges";
import { EDIT_MODEL, EditCohortModel } from "./EditCohortModel";

const isPlainObject = (val) =>
  val !== null &&
  typeof val === "object" &&
  !Array.isArray(val) &&
  Object.getPrototypeOf(val) === Object.prototype;

const CohortView = ({ isAddRemoveInProgress, setIsAddRemoveInProgress }) => {
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();
  const [disableSaveCohort, setDisableSaveCohort] = useState(true);
  const [showCreateCohortModel, setShowCreateCohortModel] = useState(false);
  const [switchCreateModel, setSwitchCreateModel] = useState(
    CREATE_MODEL.CREATE,
  );
  const [showEditCohortModel, setShowEditCohortModel] = useState(false);
  const [switchEditModel, setSwitchEditModel] = useState(EDIT_MODEL.EDIT);
  const [institutions, setInstitutions] = useState(null);
  const [showEmptyMessage, setShowEmptyMessage] = useState(false);

  const selectedAdditionalInstitutions = useSelector(
    (state) => state?.cohortReducer?.selectedAdditionalInstitutions,
  );

  const selectedInstitutions = useSelector(
    (state) => state?.cohortReducer?.selectedInstitutions,
  );

  const cohortApplied = useSelector(
    (state) => state?.cohortReducer?.cohortApplied,
  );

  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  const isFieldsEditiable = useSelector(
    (state) => state?.cohortReducer?.isFieldsEditiable,
  );

  const isEditCohort = useSelector(
    (state) => state?.cohortReducer?.isEditCohort,
  );

  useEffect(() => {
    let flag = true;
    if (cohortApplied?.cohort?.selected?.length) {
      flag = false;
    } else if (isEditCohort && selectedInstitutions?.length) {
      flag = false;
    } else if (!isEditCohort) {
      if (selectedInstitutions?.length) {
        flag = false
      } else {
        flag = true
      }
    }
    setDisableSaveCohort(flag);
  }, [selectedCohort, selectedInstitutions, isEditCohort]);

  const {
    data: initialInstitutions,
    isError: isErrorInitialInstitutions,
    isLoading: isLoadingInitialInstitutions,
  } = useFetch(useGetInitialFIListQuery, {});

  useEffect(() => {
    if (isPlainObject(initialInstitutions)) {
      if (cohortApplied?.cohort != null) {
        if (cohortApplied?.cohort?.selected?.length >= 0) {
          const selectedInstitutions = cohortApplied?.cohort?.selected?.map(
            (i) => ({
              value: i,
              label: initialInstitutions[i]?.financialInstitute,
            }),
          );
          const _unselected = Object.keys(initialInstitutions).filter(
            (key) =>
              !cohortApplied?.cohort?.selected?.includes(parseInt(key, 10)),
          );
          const unselectedInstitutions = _unselected?.map((i) => ({
            value: i,
            label: initialInstitutions[i]?.financialInstitute,
          }));
          dispatch(setSelectedInstitutions(selectedInstitutions));
          dispatch(setSelectedAdditionalInstitutions(unselectedInstitutions));
        } else {
          dispatch(setSelectedInstitutions([]));
          dispatch(setSelectedAdditionalInstitutions([]));
        }
      } else {
        if (selectedCohort?.filterJson?.selected?.length >= 0) {
          const selectedInstitutions =
            selectedCohort?.filterJson?.selected?.map((i) => ({
              value: i,
              label: initialInstitutions[i]?.financialInstitute,
            }));
          const _unselected = Object.keys(initialInstitutions).filter(
            (key) =>
              !selectedCohort?.filterJson?.selected?.includes(
                parseInt(key, 10),
              ),
          );
          const unselectedInstitutions = _unselected?.map((i) => ({
            value: i,
            label: initialInstitutions[i]?.financialInstitute,
          }));
          dispatch(setSelectedInstitutions(selectedInstitutions));
          dispatch(setSelectedAdditionalInstitutions(unselectedInstitutions));
        } else {
          dispatch(setSelectedInstitutions([]));
          dispatch(setSelectedAdditionalInstitutions([]));
        }
      }
    } else {
      dispatch(setSelectedInstitutions([]));
      dispatch(setSelectedAdditionalInstitutions([]));
    }
  }, [cohortApplied, selectedCohort, initialInstitutions]);

  // useEffect(() => {
  //   if (isPlainObject(initialInstitutions)) {
  //     if (cohortApplied?.cohort != null) {
  //       if (cohortApplied?.cohort?.selected?.length > 0) {
  //         const selectedInstitutions = cohortApplied?.cohort?.selected?.map(
  //           (i) => ({
  //             value: i,
  //             label: initialInstitutions[i]?.financialInstitute,
  //           }),
  //         );
  //         dispatch(setSelectedInstitutions(selectedInstitutions));
  //       } else {
  //         dispatch(setSelectedInstitutions([]));
  //       }
  //       if (cohortApplied?.cohort?.unselected?.length > 0) {
  //         const unselectedInstitutions = cohortApplied?.cohort?.unselected?.map(
  //           (i) => ({
  //             value: i,
  //             label: initialInstitutions[i]?.financialInstitute,
  //           }),
  //         );
  //         dispatch(setSelectedAdditionalInstitutions(unselectedInstitutions));
  //       } else {
  //         dispatch(setSelectedAdditionalInstitutions([]));
  //       }
  //     } else {
  //       if (selectedCohort?.filterJson?.institutions?.selected?.length > 0) {
  //         const selectedInstitutions =
  //           selectedCohort?.filterJson?.institutions?.selected?.map((i) => ({
  //             value: i,
  //             label: initialInstitutions[i]?.financialInstitute,
  //           }));
  //         dispatch(setSelectedInstitutions(selectedInstitutions));
  //       } else {
  //         dispatch(setSelectedInstitutions([]));
  //       }

  //       if (selectedCohort?.filterJson?.institutions?.unselected?.length > 0) {
  //         const unselectedInstitutions =
  //           selectedCohort?.filterJson?.institutions?.unselected?.map((i) => ({
  //             value: i,
  //             label: initialInstitutions[i]?.financialInstitute,
  //           }));
  //         dispatch(setSelectedAdditionalInstitutions(unselectedInstitutions));
  //       } else {
  //         dispatch(setSelectedAdditionalInstitutions([]));
  //       }
  //     }
  //   } else {
  //     dispatch(setSelectedInstitutions([]));
  //     dispatch(setSelectedAdditionalInstitutions([]));
  //   }
  // }, [cohortApplied, selectedCohort, initialInstitutions]);

  useEffect(() => {
    setInstitutions(null);
  }, [selectedCohort, cohortApplied]);

  useEffect(() => {
    setTimeout(() => {
      setInstitutions(sortInstitutions(selectedInstitutions));
    }, 500);
  }, [selectedInstitutions]);

  useEffect(() => {
    let timer;

    if (institutions !== null && institutions.length === 0) {
      timer = setTimeout(() => {
        setShowEmptyMessage(true);
      }, 1500);
    } else {
      setShowEmptyMessage(false);
    }

    return () => clearTimeout(timer);
  }, [institutions]);

  return (
    <>
      <div className="view-cohort">
        <div className="cohort-header">
          <div className="cohort-summary">
            <div className="top-section">
              {isEditCohort ? <h3>Edit Cohort</h3> : <h3>View Your Cohort</h3>}

              <div className="summary-card">
                {selectedCohort != null && (
                  <>
                    <h4>{selectedCohort?.name}</h4>
                    {/* <p>{selectedCohort?.description}</p> */}
                  </>
                )}
              </div>
            </div>
            {/* <div className="bottom-section">
              <div className="stats-row">
                <div>
                  {selectedCohort != null ? (
                    <>
                      <label>Institutions</label>
                      <strong>
                        {selectedCohort?.cohortResult?.institution_count}
                      </strong>
                    </>
                  ) : (
                    <>
                      <label>Institutions</label>
                    </>
                  )}
                </div>
                <div>
                  {selectedCohort != null ? (
                    <>
                      <label>Cohort Average</label>
                      <strong>
                        {selectedCohort?.cohortResult?.cohort_avg}
                      </strong>
                    </>
                  ) : (
                    <>
                      <label>Cohort Average</label>
                    </>
                  )}
                </div>
                <div>
                  {selectedCohort != null ? (
                    <>
                      <label>Percentile</label>
                      <strong>
                        {selectedCohort?.cohortResult?.percentile}
                      </strong>
                    </>
                  ) : (
                    <>
                      <label>Percentile</label>
                    </>
                  )}
                </div>
              </div>
            </div> */}
          </div>
          <div className="bank-details">
            <div className="bank-list">
              <h5>Financial Institutions in Cohort</h5>
              {selectedCohort != null || cohortApplied?.cohort != null ? (
                <>
                  {/* <p>View Bank Names in the cohort here.</p> */}

                  {/* <div className="list-container">
                    <div className="bank-group">
                      {institutions?.length > 0 ? (
                        institutions?.map((i) => {
                          return (
                            <div className="group">
                              <div className="group-id">{i.label}</div>
                              <ul>
                                {i?.options?.map((fi) => {
                                  // const ids =
                                  //   selectedAdditionalInstitutions?.map(
                                  //     (i) => i?.value,
                                  //   ) || [];
                                  // const isChecked = ids?.includes(fi?.value);
                                  return (
                                    <li
                                      key={fi.value}
                                      className="fi-selection"
                                      // onMouseDown={(e) => addSelectedInstitution(e, fi)}
                                    >
                                      <label>{fi?.label}</label>
                                      <div
                                        className={`remove ${selectedCohort != null ? "disabled" : ""}`}
                                        onClick={() =>
                                          selectedCohort === null &&
                                          removeInstitutionToCohort(fi)
                                        }
                                      >
                                        <FiMinus />
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          );
                        })
                      ) : (
                        <div className="group">
                          {showEmptyMessage ? (
                            <div className="group-id">
                              No institutions found!
                            </div>
                          ) : (
                            [...Array(13)].map((_, i) => (
                              <div style={{ marginBottom: "1rem" }}>
                                <Skeleton width="100%" height="2rem" />
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>
                  </div> */}
                  <div className="list-container">
                    <div className="bank-group">
                      <div className="group">
                        <ul className="h-100">
                          {!isAddRemoveInProgress &&
                            institutions?.length > 0 ? (
                            institutions?.map((fi) => {
                              return (
                                <li
                                  key={fi.value}
                                  className="fi-selection"
                                // onMouseDown={(e) => addSelectedInstitution(e, fi)}
                                >
                                  <label>{fi?.label}</label>
                                  <div
                                    className={`remove ${!isFieldsEditiable ? "disabled" : ""}`}
                                    // className={`remove`}
                                    onClick={() => {
                                      if (!isFieldsEditiable) return;
                                      setIsAddRemoveInProgress(true);
                                      dispatch(removeInstitution(fi));
                                      dispatch(setResetSearchTextForCities(true));
                                    }}
                                  >
                                    <FiMinus />
                                  </div>
                                </li>
                              );
                            })
                          ) : (
                            <div className="group h-100">
                              {showEmptyMessage ? (
                                <div className="group-id">
                                  No institutions found!
                                </div>
                              ) : (
                                // <div
                                //   className="d-flex justify-content-center"
                                //   style={{
                                //     minHeight: "42rem",
                                //   }}
                                // >
                                //   <div className="d-flex justify-content-center">
                                //     <SectionLoader />
                                //   </div>
                                // </div>
                                [...Array(19)].map((_, i) => (
                                  <div style={{ marginBottom: "1rem" }}>
                                    <Skeleton width="100%" height="2rem" />
                                  </div>
                                ))
                              )}
                            </div>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="message-container">
                  <div className="message">
                    <div className="no_cohort">
                      <img alt="icon" src={exportimages.no_cohort_bank} />
                    </div>
                    <div className="message">Build your Cohort</div>
                    <div className="desc">
                      Build a cohort using filters on the left. Financial
                      Institutions included in your custom cohort will show up
                      in this column.
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <div className="cohort-footer">
        <div className="removed-section">
          <div className="select-field">
            <FiSearch className="search-icon" />
            <input
              className="search-input"
              placeholder="Search institutions"
              // onChange={onSearch}
            />
          </div>
          <div className="removed-card">
            <div className="top">
              <strong>Removed Institutions</strong>
              <button>Clear</button>
            </div>
            <span className="bank">Huntington National Bank</span>
          </div>
        </div>
      </div> */}
        <div className="filter-footer">
          {/* <button className="clear-btn">Clear all</button> */}
          <div></div>
          {hasPermission(PRIVILEGES.CREATE_COHORT) && (
            <button
              className={`apply-btn ${!hasSubscription(PRIVILEGES.CREATE_COHORT) || disableSaveCohort ? "disabled" : ""}`}
              disabled={
                !hasSubscription(PRIVILEGES.CREATE_COHORT) || disableSaveCohort
              }
              onClick={() => {
                if (isEditCohort) {
                  setShowEditCohortModel(true);
                  setSwitchEditModel(EDIT_MODEL.EDIT);
                } else {
                  setSwitchCreateModel(CREATE_MODEL.CREATE);
                  setShowCreateCohortModel(true);
                }
              }}
            >
              Save Cohort
            </button>
          )}
        </div>
      </div>
      <CreateCohortModel
        show={showCreateCohortModel}
        onHide={() => setShowCreateCohortModel(false)}
        switchCreateModel={switchCreateModel}
        setSwitchCreateModel={setSwitchCreateModel}
      />
      <EditCohortModel
        show={showEditCohortModel}
        onHide={() => setShowEditCohortModel(false)}
        uid={selectedCohort?.uid}
        title={selectedCohort?.name}
        subtitle={selectedCohort?.description}
        switchEditModel={switchEditModel}
        setSwitchEditModel={setSwitchEditModel}
      />
    </>
  );
};
export default CohortView;
